/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
import StepeperProcesos from "../stepperProcesos";
export default function PreOperatorio() {
  const steps = [
    {
      numero: "1",
      titulo: "CIRUGÍA",
      pasos: ["Se Realizará en la fecha agendada en el Centro Médico ABC Campus Santa Fé."],
      roles: [93, 100],
    },
    {
      numero: "2",
      titulo: "INFORMES",
      pasos: ["Subir informes quirúrgico:", "- Otorrino", "- Audiología"],
      roles: [100],
    },
    {
      numero: "3",
      titulo: "CITAS",
      pasos: ["Agendar cita ORL para revisión a los 7 días de la cirugía"],
      roles: [],
    },
  ];

  return <StepeperProcesos steps={steps} />;
}
